import { UserSchemaType } from "@/components/validations/user";
import { iBachelorDegree, iLanguageCertificate, iMasterDegree, iScholarship } from "@/types/models";

export const emptyBachelorDegree: iBachelorDegree = {
	id: "",
	majorCode: "",
	major: "",
	cccd: "",
	studentId: "",
	studentName: "",
	dateOfBirth: undefined,
	placeOfBirth: "",
	gender: "",
	ethnicCode: "",
	ethnicity: "",
	nationalityCode: "",
	nationality: "",
	graduationYear: "",
	classification: "",
	classificationId: "",
	trainingMode: "",
	degreeNumber: "",
	registrationNumber: "",
	signedBy: "",
	signerTitle: "",
	signDate: undefined,
	course: "",
	recognitionDecisionNumber: "",
	requestTypeId: "",
	requestType: "",
	notes: "",
	status: "Nội bộ",
};

export const emptyMasterDegree: iMasterDegree = {
	id: "",
	majorCode: "",
	major: "",
	cccd: "",
	studentId: "",
	studentName: "",
	dateOfBirth: undefined,
	placeOfBirth: "",
	gender: "",
	ethnicCode: "",
	ethnicity: "",
	nationalityCode: "",
	nationality: "",
	trainingMode: "",
	degreeNumber: "",
	registrationNumber: "",
	signedBy: "",
	signerTitle: "",
	signDate: undefined,
	course: "",
	defenseDate: undefined,
	recognitionDecisionNumber: "",
	requestTypeId: "",
	requestType: "",
	notes: "",
	status: "Nội bộ",
};

export const emptyLanguageCertification: iLanguageCertificate = {
	id: "",
	certificateNumber: "",
	cccd: "",
	studentId: "",
	studentName: "",
	dateOfBirth: undefined,
	placeOfBirth: "",
	gender: "",
	ethnicCode: "",
	ethnicity: "",
	nationalityCode: "",
	nationality: "",
	language: "",
	languageCode: "",
	level: "",
	// examDate: new Date(),
	// issueDate: new Date(),
	// expiryDate: new Date(),
	examCenter: "",
	totalScore: 0,
	listeningScore: 0,
	speakingScore: 0,
	readingScore: 0,
	writingScore: 0,
	certificateType: "",
	certificateTypeId: "",
	signedBy: "",
	signerTitle: "",
	signDate: undefined,
	notes: "",
	status: "Nội bộ",
	classification: "",
	classificationId: "",
	courseStart: undefined,
	courseEnd: undefined,
	languageLevel: "",
	registrationNumber: "",
	requestType: "",
	requestTypeId: "",
};

export const emptyScholarship: iScholarship = {
	id: "",
	majorCode: "",
	major: "",
	year: "",
	semester: "",
	studentId: "",
	studentName: "",
	dateOfBirth: undefined,
	cccd: "",
	gpa: "",
	conductScore: "",
	scholarshipCode: "",
	scholarshipName: "",
	title: "",
	amount: "",
	certificateNo: "",
	percentLevel: "",
	notes: "",
};
export const emptyUser: UserSchemaType = {
	id: "",
	name: "",
	email: "",
	username: "",
	role: "",
	status: "active",
	department: "",
	position: "",
	phone: "",
	permissions: [],
};

export const emptyScholarshipTitle = {
	id: "",
	titleName: "",
	currentTitleName: "",
	description: "",
};